export default __webpack_public_path__ + "static/media/victor-team.5dadc8e6.png";